import {
  useState,
  useEffect,
  useCallback,
  useContext,
  createContext,
} from 'react'
import { backend } from 'src/config'
import axios from 'src/utils/axios'

export let refetchEnums = async () => {}

export const useFetchEnums = () => {
  const [enums, setEnums] = useState(null)

  const fetchEnums = useCallback(async () => {
    const token = localStorage.getItem('accessToken')
    if (!token) return
    try {
      const response = await axios.get(`${backend}/api/enums`)
      setEnums(response.data)
    } catch (e) {
      console.error('Errors fetching enums', e)
      setEnums(null)
    }
  }, [])

  // register global refetch
  useEffect(() => {
    refetchEnums = fetchEnums
    return () => {
      refetchEnums = async () => {}
    }
  }, [fetchEnums])

  useEffect(() => {
    fetchEnums()
  }, [fetchEnums])

  return enums
}

export const EnumsContext = createContext({})

export const useEnums = () => useContext(EnumsContext)
